import React, {useContext, useEffect, useState, useRef} from "react";
import HulpstukChart from "../Data/HulpstukChart";
import axios from "axios";
import {useParams} from "react-router-dom";

const HulpstukInfo = () => {
  const { serialNumber } = useParams();
  const [machine, setMachine] = useState(null)
  const [averages, setAverages] = useState({})

  useEffect( () => {
    const loadMachine = async () => {
      const response = await axios.get(`/api/machine/get/${serialNumber}`)
      setMachine(response.data);
    }

    loadMachine();
  }, [serialNumber]);

  useEffect( () => {
    const calculateAverage = () => {
      if (!machine?.hulpstukken) return
      const tmpAverages = {}
      machine.hulpstukken.forEach((hulpstuk) => {
        if (!hulpstuk.vermogen) return
        let average = 0
        let count = 0
        Object.values(hulpstuk.vermogen).forEach((value) => {
          average += value
          count += 1
        })
        tmpAverages[hulpstuk.naam] = ((average / count / 1000)).toFixed(2)
        console.log(average / count)
      })
      setAverages(tmpAverages)
    }

    calculateAverage();
  }, [machine]);

  if (!machine) return

  return (
    <div className="flex w-full h-full grow flex-col items-center gap-5 bg-white rounded-md shadow-lg justify-center p-8">
      <h1 className={"text-gray-700 font-bold pl-3 text-3xl"}>(Experimentele) Hulpstuk Lijst</h1>
      <ul className="flex flex-col gap-4 w-full h-full overflow-y-scrollbar relative overflow-auto grow">
        {machine.hulpstukken.length > 0 ? machine.hulpstukken.map((hulpstuk, index) => (
          <li key={index} className="w-full flex text-xl gap-2 text-gray-300 p-2 pl-3 rounded-lg border-gray-400 placeholder-gray-300 focus:outline-hidden focus:border-gray-600  border leading-normal">
            <span style={{background: hulpstuk.kleur}} className={"w-10 h-10 rounded-sm"}></span>
            <h1 className="text-gray-700 w-1/6 select-none">{hulpstuk.naam}</h1>
            <h1 className="text-gray-700 w-1/12 select-none">{hulpstuk.nummer}</h1>
            <h1 className="text-gray-700 w-1/6 select-none">Gemiddeld Verbruik: {averages[hulpstuk.naam] || 0} kWh</h1>
            <HulpstukChart data={hulpstuk.vermogen} serialNumber/>
          </li>
        )): ""}
      </ul>
    </div>
  )
}

export default HulpstukInfo;